import { Dispatch } from 'redux';
import EspController from '../controllers/EspController';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class EspCRUDActions extends CrudActionContainer {
  constructor() {
    super('ESP');
  }

  getDomains(pageId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));

      try {
        const response = await EspController.getDomains(pageId);
        dispatch(this.retrievedAll(response.domains));

        return response;
      } catch (error) {
        await commonHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  createDomain(args: { facebookPageId: number; domain: string }) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.createAction));
      try {
        const response = await EspController.postDomain(args);
        dispatch(this.retrieved(response.domain));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  validateDomain(domainId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAction));
      try {
        const response = await EspController.validateDomain(domainId);
        dispatch(this.retrieved(response.domain));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  destroyDomain(domainId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.deleteAction));
      try {
        const response = await EspController.destroyDomain(domainId);
        dispatch(this.deleteLocal(response));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }
}

const espCRUDActions = new EspCRUDActions();

export default espCRUDActions;

export const useEspCRUDActions = getActionHookBuilder(espCRUDActions, [
  'createDomain',
  'getDomains',
  'validateDomain',
  'destroyDomain',
]);
